import { render, staticRenderFns } from "./TakeCustodyModal.vue?vue&type=template&id=52436c6a&scoped=true&"
import script from "./TakeCustodyModal.vue?vue&type=script&lang=js&"
export * from "./TakeCustodyModal.vue?vue&type=script&lang=js&"
import style0 from "./TakeCustodyModal.vue?vue&type=style&index=0&id=52436c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52436c6a",
  null
  
)

export default component.exports